import { useLang } from "@/context/LanguageContext";

export default function LanguageToggle({ className = "" }) {
  const { lang, changeLang } = useLang();
  return (
    <div
      className={`flex items-center rounded-full border-2 border-[#14283A] p-0.5 ${className}`}
      data-testid="lang-toggle"
    >
      {["fr", "en"].map((l) => (
        <button
          key={l}
          onClick={() => changeLang(l)}
          data-testid={`lang-${l}`}
          aria-pressed={lang === l}
          className={`rounded-full px-2.5 py-1 text-xs font-bold uppercase transition-colors ${
            lang === l ? "grad-bar text-white" : "text-[#14283A] hover:text-[#EA7A4F]"
          }`}
        >
          {l}
        </button>
      ))}
    </div>
  );
}
